import _fixRtlText from "../functions/utility/fixRtlText.js";
import _quillClasses from "../dict/quillClasses.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _cavenaFunc from "../functions/profiles/cavena890.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const getFormatOptions = _getFormatOptions;
const cavenaFunc = _cavenaFunc;
const convertToHtml = _convertToHtml;
const quillClasses = _quillClasses;
const fixRtlText = _fixRtlText;
export default {
  decode: function (input, options) {
    let events = [],
      line,
      decodingOptions = getFormatOptions(options.formatOptions);
    let decodeLineA = decodingOptions["Decode Line 1"] && decodingOptions["Decode Line 1"].toLowerCase() === "no" ? false : true;
    let decodeLineB = decodingOptions["Decode Line 2"] && decodingOptions["Decode Line 2"].toLowerCase() === "no" ? false : true;
    let inputHex = input.match(/(..?)/g);
    let header = inputHex.splice(0, 388);
    let primaryLang = cavenaFunc.languageCodes[header[146]];
    let secondaryLang = cavenaFunc.languageCodes[header[147]];
    let som = cavenaFunc.hexArrayToAscii(header.slice(256, 267));
    let lowByte = parseInt(header[208], 16);
    let highByte = parseInt(header[209], 16);

    // console.log(som);
    // console.log(primaryLang);
    // console.log(secondaryLang);
    // console.log("--------------------");

    let totalEvents = lowByte + (highByte << 8) + 1;
    // console.log(totalEvents);
    while (inputHex.length > 0) {
      try {
        let eventBlock = {
          raw: inputHex.splice(0, 128)
        };
        eventBlock.sn = eventBlock.raw[0] + eventBlock.raw[1];
        eventBlock.start = eventBlock.raw.slice(2, 5);
        eventBlock.end = eventBlock.raw.slice(5, 8);
        eventBlock.alignment = eventBlock.raw[8].split("");
        eventBlock.controlCodes = eventBlock.raw.slice(9, 16);
        eventBlock.lineA = eventBlock.raw.slice(16, 67);
        eventBlock.seperator = eventBlock.raw.slice(67, 73);
        eventBlock.lineB = eventBlock.raw.slice(73, 124);
        eventBlock.terminator = eventBlock.raw.slice(124);
        // console.log(events.length + 1);
        // console.log(eventBlock);
        let subtitle = new Event();
        subtitle.start = tcLib.framesToSec(cavenaFunc.decodeFrameCount(eventBlock.start), options.frameRate);
        subtitle.end = tcLib.framesToSec(cavenaFunc.decodeFrameCount(eventBlock.end), options.frameRate);
        subtitle.alignment = eventBlock.alignment[1] == "0" ? "left" : eventBlock.alignment[1] == "2" ? "right" : "center";
        subtitle.xPos = eventBlock.alignment[1] == "0" ? "start" : eventBlock.alignment[1] == "2" ? "end" : "center";
        subtitle.yPos = cavenaFunc.decodeYPos(eventBlock.seperator, options.window.height);
        if (decodeLineA) {
          line = cavenaFunc.decodeTextLine(eventBlock.lineA, primaryLang);
          if (primaryLang === "hebrew" || primaryLang === "arabic") {
            line = fixRtlText(line);
            // console.log("primaryLang: " + line);
          }
          subtitle.text += line + "\n";
        }
        if (decodeLineB) {
          line = cavenaFunc.decodeTextLine(eventBlock.lineB, secondaryLang);
          if (secondaryLang === "hebrew" || secondaryLang === "arabic") {
            line = fixRtlText(line);
            // console.log("secondaryLang: " + line);
          }
          subtitle.text += line + "\n";
        }
        subtitle.text = convertToHtml(subtitle.text, [quillClasses.align[subtitle.alignment]]);

        // console.log(subtitle.text, subtitle.start, subtitle.end);
        // console.log(subtitle.text);
        // console.log("----");

        events.push(subtitle);
      } catch (err) {
        /* End of subtitle block */
        console.log(err.message);
      }
    }
    return events;
  },
  encode: function (eventGroup, options) {
    let encodingOptions = getFormatOptions(options.formatOptions);
    //console.log(encodingOptions);
    let langA = encodingOptions["Line 1 Language"] || "english";
    let langB = encodingOptions["Line 2 Language"] || "english";
    let som = encodingOptions["SOM"] || "00:00:00:00";
    let tapeNumber = encodingOptions["Tape Number"] ?? "Unknown";
    let programmeTitle = encodingOptions["Programme Title"] ?? "Unknown Title";
    let translatedProgrammeTitle = encodingOptions["Translated Programme Title"] ?? "Unknown Title";
    let translator = encodingOptions["Translator"] ?? "Unknown Translator";
    let translatedEpTitle = encodingOptions["Translated Episode Title"] ?? "Uknown Episode";
    let comments = encodingOptions["comments"] ?? "Created by CCC";
    let fontA = encodingOptions["Font Family Line 1"] ?? "auto";
    let fontB = encodingOptions["Font Family Line 2"] ?? "auto";
    let rtlTextProcessing = encodingOptions["RTL Text Processing"] ?? "no";
    langA = langA.toLowerCase();
    langB = langB.toLowerCase();
    fontA = fontA === 'auto' ? cavenaFunc.fontCodes[langA] : fontA;
    fontB = fontB === 'auto' ? cavenaFunc.fontCodes[langB] : fontB;
    let output = cavenaFunc.encodeHeader(eventGroup, langA, langB, som, tapeNumber, programmeTitle, translatedProgrammeTitle, translator, translatedEpTitle, comments, fontA, fontB);

    // console.log("----Header----");
    // console.log(output);
    // console.log("-----");

    eventGroup.events.forEach((event, index, events) => {
      //number
      // console.log("-----")
      let eventCodes = "";
      let subtitleNumber = "";
      let tcCodes = "";
      let alignmentCode = "";
      let controlCodes = "00000000000000";
      subtitleNumber += parseInt((index + 1) * 16 / 256).toString(16).padStart(2, "0");
      subtitleNumber += parseInt((index + 1) * 16 % 256).toString(16).padStart(2, "0");

      /* Timecode */
      let startFrameBytes = cavenaFunc.secondsToFrameBytes(event.start, options.frameRate);
      let endFrameBytes = cavenaFunc.secondsToFrameBytes(event.end, options.frameRate);
      tcCodes += startFrameBytes;
      tcCodes += endFrameBytes;

      /* Alignment - determine from xPos (flexbox or integer) */
      let horizontalPosition = "center";
      if (typeof event.xPos === 'number') {
        // Convert integer position to flexbox using percentage thresholds
        // Cavena 890 typically uses 32-character width display
        const displayWidth = 32;
        const percentage = event.xPos / displayWidth * 100;
        if (percentage <= 33) {
          horizontalPosition = "left";
        } else if (percentage >= 67) {
          horizontalPosition = "right";
        } else {
          horizontalPosition = "center";
        }
      } else if (event.xPos === "start") {
        horizontalPosition = "left";
      } else if (event.xPos === "end") {
        horizontalPosition = "right";
      } else if (event.xPos === "center") {
        horizontalPosition = "center";
      } else if (event.alignment) {
        // Fallback to alignment property if xPos not set
        horizontalPosition = event.alignment;
      }
      if (horizontalPosition === "left") {
        alignmentCode += "10";
      } else if (horizontalPosition === "right") {
        alignmentCode += "12";
      } else {
        alignmentCode += "14"; //Center
      }

      /* Text */
      let textCodes = cavenaFunc.encodeText(event, langA, langB, index === events.length - 1, event.yPos, options.window.height, rtlTextProcessing);

      /* Packet Order */
      /* 
          Subtitle Number
          Start Time
          End Time
          Alignment
          Reserved Control Bytes (7 bytes / 14 length)
          Line 1 Text
          Line Seperator
          Line 2 Text
          Entry Terminator (padding)
      */

      // console.log("-------");
      // console.log(subtitleNumber);
      // console.log(startFrameBytes);
      // console.log(endFrameBytes);
      // console.log(alignmentCode);
      // console.log(controlCodes);
      // console.log(textCodes);

      eventCodes += subtitleNumber;
      eventCodes += tcCodes;
      eventCodes += alignmentCode;
      eventCodes += controlCodes;
      eventCodes += textCodes;
      output += eventCodes;
    });
    return output;
  },
  preProcess: {
    encode: function (eventGroup) {
      return eventGroup;
    },
    decode: function (input) {
      return input.toLowerCase();
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};